// Single source of truth for the backend base URL. Imported by the auth layer,
// the API client, and the ambient quick-score client so they never drift.
//
// Local dev: the task pane is served over HTTPS from localhost:3000, which
// cannot call an HTTP backend (mixed content). So in dev we use a RELATIVE base
// ("") — calls hit https://localhost:3000/api/... and the webpack dev-server
// proxies them to the local backend (http://localhost:8000). No backend HTTPS,
// no CORS needed. In production we call the hosted backend directly.
const isLocalhost =
  typeof window !== "undefined" && window.location.hostname === "localhost";

export const BACKEND_URL = isLocalhost
  ? ""
  : "https://backend.othercentered.com";
